import script from "./FileDownloader.vue?vue&type=script&setup=true&lang=js"
export * from "./FileDownloader.vue?vue&type=script&setup=true&lang=js"

import "./FileDownloader.vue?vue&type=style&index=0&id=0a16c576&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a16c576"]])

export default __exports__